var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 95,
    viewBox: "0 0 123 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 18.6607V66.1607C0 82.0859 12.9141 95 28.8393 95H96.6964C99.5167 95 101.786 92.731 101.786 89.9107C101.786 87.0904 99.5167 84.8214 96.6964 84.8214H28.8393C18.5335 84.8214 10.1786 76.4665 10.1786 66.1607V18.6607C10.1786 15.8404 7.9096 13.5714 5.08928 13.5714C2.26897 13.5714 0 15.8404 0 18.6607Z",
    fill: "#C9C9C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9286 74.6429H108.571C116.057 74.6429 122.143 68.5569 122.143 61.0714V27.1429C122.143 19.6574 116.057 13.5714 108.571 13.5714H83.6552C80.0502 13.5714 76.5938 12.1507 74.0491 9.60603L68.4297 3.9654C65.8851 1.42076 62.4286 0 58.8237 0H33.9286C26.4431 0 20.3572 6.08594 20.3572 13.5714V61.0714C20.3572 68.5569 26.4431 74.6429 33.9286 74.6429Z",
    fill: "#C9C9C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.adb1afd4c4a05423b035c51daf047718.svg";
export { ForwardRef as ReactComponent };